import { jsx as _jsx } from "react/jsx-runtime";
import { useDrop } from "react-dnd";
import StateKanbanCard from "@/features/taskState/components/StateKanbanCard";
const ItemType = "TASK_STATE";
const StateKanbanColumn = ({ state, onSwitch, onEdit, onDelete, totalItems }) => {
    const [, drop] = useDrop({
        accept: ItemType,
        drop: (item) => {
            onSwitch(item.state.id, state.id);
        },
    });
    return (_jsx("div", { ref: drop, className: "flex flex-col bg-gray-100 p-2 rounded shadow flex-1 min-w-[16rem]", children: _jsx(StateKanbanCard, { state: state, onEdit: () => onEdit(state), onDelete: onDelete }, state.id) }));
};
export default StateKanbanColumn;
